module.exports = __webpack_public_path__ + "img/合约交易.919f9be6.jpg";